import { render, staticRenderFns } from "./registerHeader.vue?vue&type=template&id=110dfd76&scoped=true"
import script from "./registerHeader.vue?vue&type=script&lang=js"
export * from "./registerHeader.vue?vue&type=script&lang=js"
import style0 from "./registerHeader.vue?vue&type=style&index=0&id=110dfd76&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110dfd76",
  null
  
)

export default component.exports